/** Stable selectors for the B4 prompt sections admin surface. */
export const PROMPT_SECTIONS_ADMIN = {
  page: 'prompt-sections-admin-page',
  globalTab: 'prompt-sections-global-tab',
  projectTab: 'prompt-sections-project-tab',
  promotionTab: 'prompt-sections-promotion-tab',
  globalList: 'prompt-sections-global-list',
  globalPack: (packId: string) => `prompt-sections-global-pack-${packId}`,
  globalJson: 'prompt-sections-global-json',
  globalValidate: 'prompt-sections-global-validate',
  globalPublish: 'prompt-sections-global-publish',
  globalHistory: 'prompt-sections-global-history',
  globalRollback: (version: number) => `prompt-sections-global-rollback-${version}`,
  projectId: 'prompt-sections-project-id',
  projectRefresh: 'prompt-sections-project-refresh',
  projectList: 'prompt-sections-project-list',
  projectNew: 'prompt-sections-project-new',
  projectExample: (exampleId: string) => `prompt-sections-project-example-${exampleId}`,
  projectDrawer: 'prompt-sections-project-drawer',
  projectExampleId: 'prompt-sections-project-example-id',
  projectExampleJson: 'prompt-sections-project-example-json',
  projectExampleSave: 'prompt-sections-project-example-save',
  projectExampleDelete: 'prompt-sections-project-example-delete',
  promotionProjectId: 'prompt-sections-promotion-project-id',
  promotionLoad: 'prompt-sections-promotion-load',
  promotionList: 'prompt-sections-promotion-list',
  promotionCandidate: (subtypeId: string) => `prompt-sections-promotion-candidate-${subtypeId}`,
  promotionOpen: (subtypeId: string) => `prompt-sections-promotion-open-${subtypeId}`,
  promotionDrawer: 'prompt-sections-promotion-drawer',
  promotionClose: 'prompt-sections-promotion-close',
  promotionStepper: 'prompt-sections-promotion-stepper',
  promotionTargetType: 'prompt-sections-promotion-target-type',
  promotionDryRun: 'prompt-sections-promotion-dry-run',
  promotionReceipt: 'prompt-sections-promotion-receipt',
  promotionConfirmation: 'prompt-sections-promotion-confirmation',
  promotionPendingApply: 'prompt-sections-promotion-pending-apply',
  promotionSchemaChecklist: 'prompt-sections-promotion-schema-checklist',
  promotionSchemaRefresh: 'prompt-sections-promotion-schema-refresh',
  promotionCompleteApply: 'prompt-sections-promotion-complete-apply',
  promotionCompletedReceipt: 'prompt-sections-promotion-completed-receipt',
  promotionRollbackDryRun: 'prompt-sections-promotion-rollback-dry-run',
  promotionRollbackApply: 'prompt-sections-promotion-rollback-apply',
  promotionRolledBackReceipt: 'prompt-sections-promotion-rolled-back-receipt',
  statusMessage: 'prompt-sections-status-message',
} as const;
